export const URLGED = "https://gedfi.inserm.fr";
